// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'speaker';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M8.025 6.75H4.781a.563.563 0 0 0-.562.563v3.375a.563.563 0 0 0 .562.562h3.244a6.19 6.19 0 0 0 5.14 3.907.563.563 0 0 0 .62-.56V3.403a.562.562 0 0 0-.62-.56 6.19 6.19 0 0 0-5.14 3.907z'
  />
);

export const viewBox = '0 0 18 18';
